
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiLogic07Off as ObiLogic07OffElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-logic-07-off.js';
 
 
 

 
 export const ObiLogic07Off = createComponent({
   react: React,
   tagName: 'obi-logic-07-off',
   elementClass: ObiLogic07OffElement,
   events: {
     
   }
  });
 
 